import styles from './AuditInfoPanel.module.css'

interface DefectsSectionProps {
  defects: string[]
}

function DefectsSection({ defects }: DefectsSectionProps) {
  return (
    <div className={styles.defectsSection}>
      <h3 className={styles.sectionLabel}>Defects</h3>
      {defects.length > 0 ? (
        <ul className={styles.defectsList}>
          {defects.map((defect, index) => (
            <li
              key={index}
              className={styles.defectItem}
            >
              {defect}
            </li>
          ))}
        </ul>
      ) : (
        <p className={styles.emptyState}>No defects configured</p>
      )}
    </div>
  )
}

export default DefectsSection
